export default __webpack_public_path__ + "static/media/Perk_3.1992d578.png";